module.exports = __webpack_public_path__ + "img/thumbs.b285d4f.svg";